<template>
  <div class="content-with-sidebar">
    <div class="main-box">
      <slot name="main" />
    </div>
    <div class="sidebar-box">
      <slot name="sidebar"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContentWithSidebar'
}
</script>

<!--suppress CssInvalidAtRule -->
<style lang="scss">
  @import "../../../../styles/vars";
  @import "../../../../styles/mixins";
  $sidebar-width: $max-width-sidebar;

  .content-with-sidebar {
    position: relative;
    display: block;
    /*flex-direction: column;*/
    /*justify-content: center;*/
    width: 100%;
    height: 100%;
    padding: $base-padding 0;
    overflow-y: auto;
    flex: 1;
    min-height: 0;

    @media (max-width: $max-width-phone) {
      padding: 0 !important;
      overflow-x: hidden !important;
      overflow-y: auto !important;
      height: 100% !important;
      min-height: 0 !important;
      flex: 1 1 auto !important;
      -webkit-overflow-scrolling: touch !important;
      scroll-behavior: smooth;
      touch-action: pan-y;
    }

    & > * {
      position: relative;
      //padding-top: $base-size;
    }
    .main-box {
      flex-shrink: 1;
      flex-grow: 1;
      min-width: 0;
      width: 100%;
      max-width: 100%;

      @media (max-width: $max-width-phone) {
        width: 100% !important;
        max-width: 100% !important;
        overflow-x: hidden !important;
        overflow-y: visible !important;
        padding-top: 0;
      }

      .text-block {
        padding: 0 $base-padding;
        max-width: 100%;
        hyphens: auto;
        overflow-wrap: break-word;
        word-wrap: break-word;

        @media (max-width: $max-width-phone) {
          padding: 0 $small-padding;
          width: 100%;
          max-width: 100%;
          overflow-x: hidden;
        }
      }
    }
    .sidebar-box {
      @apply px-base;

      @media (max-width: $max-width-phone) {
        @apply px-sm;
        padding-top: $base-padding;
      }
    }
    @include wider-then($max-width-text-block + $sidebar-width / 2) {
      & {
        display: flex;
        flex-direction: row;
        .main-box {
          overflow-y: auto !important;
          overflow-x: hidden !important;
          //max-width: calc(#{$max-width-text-block} + #{$base-padding} * 2);
          padding: 0 $base-padding * 2;
          border-right: 1px solid $color-aba-blue;
          -webkit-overflow-scrolling: touch;
          scroll-behavior: smooth;
          max-height: 100%;
        }
        .sidebar-box {
          overflow-y: auto;
          flex: 0 0 $sidebar-width;
          padding: $base-padding;
        }
      }
    }
    @include wider-then($max-width-text-block + $sidebar-width + $base-padding * 3) {
      .main-box .text-block {
        @apply px-0;
      }
    }
  }

</style>
